/* src/app/shared/components/checkbox/checkbox.component.scss */
.checkbox-container .checkbox {
  cursor: pointer;
  display: flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
}
.checkbox-container .checkbox .icon-container {
  display: flex;
  height: 1.2em;
  width: 1.2em;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 2px;
  border: 1px solid var(--tds-blue-800);
  background-color: var(--tds-white);
  color: var(--tds-white);
}
.checkbox-container .checkbox .icon-container i {
  font-size: calc(1.2em * 0.7);
}
.checkbox-container .checkbox .label-container {
  margin-left: 0.4em;
  font-size: 1.3rem;
  color: var(--tds-grey-958);
  font-family: var(--scania-font-family-semi-condensed);
}
.checkbox-container .checkbox.checked .icon-container {
  background-color: var(--tds-blue-800);
}
.checkbox-container .checkbox:hover .icon-container {
  outline: 3px solid var(--tds-grey-300);
}
.checkbox-container .checkbox.disabled {
  cursor: default;
}
.checkbox-container .checkbox.disabled .icon-container {
  background-color: var(--tds-white);
  color: var(--tds-grey-500);
  border-color: var(--tds-grey-500);
  cursor: not-allowed;
  outline: none;
}
.checkbox-container .checkbox.disabled .label-container {
  color: var(--tds-grey-600);
}
/*# sourceMappingURL=checkbox.component.css.map */
